var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CurrentFromMaxDisplaySubject_observers;
import React, { useEffect, useState } from "react";
export class CurrentFromMaxDisplaySubject {
    constructor() {
        _CurrentFromMaxDisplaySubject_observers.set(this, new Set());
    }
    observe(callback) {
        __classPrivateFieldGet(this, _CurrentFromMaxDisplaySubject_observers, "f").add(callback);
    }
    unobserve(callback) {
        __classPrivateFieldGet(this, _CurrentFromMaxDisplaySubject_observers, "f").delete(callback);
    }
    notify(current) {
        __classPrivateFieldGet(this, _CurrentFromMaxDisplaySubject_observers, "f").forEach((o) => o(current));
    }
}
_CurrentFromMaxDisplaySubject_observers = new WeakMap();
export function CurrentFromMaxDisplayObserver({ atMaxClass, initial, max, subject, }) {
    const [current, setCurrent] = useState(initial);
    useEffect(() => {
        const observerCallback = function (newCurrent) {
            setCurrent(newCurrent);
        };
        subject.observe(observerCallback);
        return () => {
            subject.unobserve(observerCallback);
        };
    }, [subject]);
    return (React.createElement(React.Fragment, null,
        current >= max ? React.createElement("span", { className: atMaxClass }, current) : current,
        "/",
        max));
}
//# sourceMappingURL=current-from-max-display.js.map